import { Link } from "react-router-dom";
import ContractLayout from "../components/ContractLayout";
import SEOHead from "../components/SEOHead";
import useIsMobile from "../hooks/useIsMobile";
import BLOG_ARTICLES from "./articles";

export default function BlogListPage() {
  const isMobile = useIsMobile();

  return (
    <>
      <SEOHead
        title="Blog — Ghiduri si Informatii Utile despre Contracte | ContractGen"
        description="Articole si ghiduri practice despre contracte, legislatie si obligatii fiscale in Romania. Informatii utile pentru proprietari, chiriasi si persoane fizice."
        canonical="https://generator-contracte.com/blog"
      />
      <ContractLayout
        title="Blog"
        subtitle="Ghiduri practice si informatii utile despre contracte si legislatie"
      >
        <div style={{ maxWidth: "900px", margin: "0 auto", padding: "40px 24px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: isMobile ? "12px" : "16px" }}>
            {BLOG_ARTICLES.map((article) => (
              <Link
                key={article.slug}
                to={`/blog/${article.slug}`}
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "16px",
                  padding: isMobile ? "24px 20px" : "28px 32px",
                  boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
                  border: "1px solid #e8e0d4",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  textDecoration: "none",
                  color: "inherit",
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: isMobile ? "flex-start" : "center",
                  gap: isMobile ? "12px" : "24px",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.boxShadow = "0 8px 32px rgba(0,0,0,0.10)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 12px rgba(0,0,0,0.04)";
                }}
              >
                <div style={{ fontSize: isMobile ? "36px" : "40px", flexShrink: 0 }}>{article.icon}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: "12px", color: "#8a7e70", marginBottom: "6px", fontWeight: 500 }}>
                    {article.date} · {article.readTime} citire
                  </div>
                  <h3 style={{
                    fontFamily: "'Playfair Display', serif",
                    fontSize: isMobile ? "18px" : "20px",
                    fontWeight: 700,
                    color: "#2d2418",
                    margin: "0 0 6px 0",
                  }}>
                    {article.title}
                  </h3>
                  <p style={{
                    fontSize: "14px",
                    color: "#8a7e70",
                    margin: 0,
                    lineHeight: 1.5,
                  }}>
                    {article.description}
                  </p>
                </div>
                <div style={{ flexShrink: 0, alignSelf: isMobile ? "flex-end" : "center" }}>
                  <span style={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#c45d3e",
                    letterSpacing: "0.02em",
                    whiteSpace: "nowrap",
                  }}>
                    Citeste →
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </ContractLayout>
    </>
  );
}
